export default __webpack_public_path__ + "assets/813bc5127b9b94287a25648d3f6be1a8.png";